<template>
  <div
    class="h-screen flex w-full bg-img"
    :style="'background-image: url('+environment.login.background+');'"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-3/4 lg:w-3/4 xl:w-3/4 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center bg-white bg-dark">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('_pages.forgot_password.title') }}</h4>
                  <p>{{ $t('_pages.forgot_password.subtitle') }}</p>
                </div>

                <vs-input
                  @keyup.enter.native="handleSubmit"
                  type="email"
                  name="email"
                  icon="icon icon-mail"
                  icon-pack="feather"
                  :label-placeholder="$t('email')"
                  v-model="email"
                  v-validate="'required|email'"
                  :data-vv-as="$t('email')"
                  class="w-full no-icon-border pt-1"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('email')"
                >{{ errors.first('email') }}</span>

                <vs-divider></vs-divider>

                <vs-button
                  @click="$router.push({name: 'loginPage', params: { partner: environment.id }})"
                  type="border"
                >{{ $t('cancel') }}</vs-button>
                <vs-button @click.prevent="handleSubmit" class="float-right">{{ $t('confirm') }}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { environment } from "@/_helpers";

export default {
  data() {
    return {
      environment: environment(),
      partner_id: environment().partner_id,
      email: ""
    };
  },
  methods: {
    ...mapActions("account", ["password_recovery"]),
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$vs.loading();
          const { partner_id, email } = this;
          const payload = {
            customer: { partner_id, email }
          };
          var vm = this;
          this.password_recovery(payload).then(
            response => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: vm.$t("_codes.e" + response.code, {
                  code: response.code
                }),
                text: vm.$t("_pages.forgot_password.success_message"),
                iconPack: "feather",
                icon: "icon-check",
                color: "success"
              });
              this.$router.push({
                name: "checkEmailForgotPassword",
                params: { partner: environment().id }
              });
            },
            error => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: vm.$t("_codes.e" + error.code, { code: error.code }),
                text: vm.$t("try_again"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });
            }
          );
        }
      });
    }
  }
};
</script>
